import { useEffect, type ReactNode } from 'react';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

import { useTraitsActions, type composeTraitsSelectors } from './TraitsStore.tsx';

const TraitsConditionalRenderer = ({
	conditions,
	children,
}: {
	conditions: ReturnType<typeof composeTraitsSelectors>;
	children: ReactNode;
}) => {
	const accountId = useAccountId();
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const { fetchTraits } = useTraitsActions();

	useEffect(() => {
		fetchTraits(conditions.traitTypes, {
			cloudId,
			accountId,
			orgId,
		});
	}, [accountId, cloudId, conditions.traitTypes, fetchTraits, orgId]);

	const shouldRenderChildren = conditions.hooks
		.map((hook) => hook()[0])
		.every((result) => Boolean(result));

	return shouldRenderChildren ? children : null;
};

export default TraitsConditionalRenderer;
